import React from 'react'
import { SimpleDialog } from '../Dialog/SimpleDialog'

type ErrorDialogProps = {
    open: boolean
    message: React.ReactNode
    onClose: () => void
    title?: string
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
    open,
    message,
    onClose,
    title = 'Fejl',
}) => {
    if (!open) return null

    return (
        <SimpleDialog title={title} message={message} closeDialog={onClose} />
    )
}
